import { render, staticRenderFns } from "./userholidays.vue?vue&type=template&id=722313c7&"
import script from "./userholidays.vue?vue&type=script&lang=js&"
export * from "./userholidays.vue?vue&type=script&lang=js&"
import style0 from "./userholidays.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports